// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  display: flex;
  flex-direction: row;
}
.content__settings {
  margin-left: 20px;
  margin-top: 20px;
  text-wrap: nowrap;
  display: flex;
  flex-direction: column;
}
.footer__social {
  align-items: center;
  flex-direction: row;
  display: flex;
  height: 100px;
  max-width: 100%;
  padding: 10px 0 0 90px;
  @media screen and (max-width: 600px) {
    padding: 20px 0 0 0;
    justify-content: center;
  }
}
.content__social-media {
  background-color: #ce354b;
  justify-content: center;
  box-sizing: border-box;
  align-items: center;
  border-radius: 50%;
  margin-right: 9px;
  display: flex;
  padding: 12px;
  height: 36px;
  width: 36px;
}
.content__footer {
  display: flex;
  flex-direction: row;
  position: absolute;
  bottom: 50px;
}
.copyright-copyright {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: normal;
  white-space: nowrap;
  color: #000;
  font-weight: bold;
  font-family: "Open Sans";
  margin-top: 23px;
  @media screen and (max-width: 600px) {
    word-break: break-word;
    margin-left: 114px;
  }
}
.copyright-copyright-all{
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: normal;
   
    color: #000;
    margin-left: 5px;
    font-family: "Open Sans";
    font-weight: normal;
    @media screen and (max-width: 600px) {
      word-break: break-word;
      margin-left: 114px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Content/Content.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;AACA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;;IAEnB,WAAW;IACX,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB;MACE,sBAAsB;MACtB,kBAAkB;IACpB;AACJ","sourcesContent":[".content {\n  display: flex;\n  flex-direction: row;\n}\n.content__settings {\n  margin-left: 20px;\n  margin-top: 20px;\n  text-wrap: nowrap;\n  display: flex;\n  flex-direction: column;\n}\n.footer__social {\n  align-items: center;\n  flex-direction: row;\n  display: flex;\n  height: 100px;\n  max-width: 100%;\n  padding: 10px 0 0 90px;\n  @media screen and (max-width: 600px) {\n    padding: 20px 0 0 0;\n    justify-content: center;\n  }\n}\n.content__social-media {\n  background-color: #ce354b;\n  justify-content: center;\n  box-sizing: border-box;\n  align-items: center;\n  border-radius: 50%;\n  margin-right: 9px;\n  display: flex;\n  padding: 12px;\n  height: 36px;\n  width: 36px;\n}\n.content__footer {\n  display: flex;\n  flex-direction: row;\n  position: absolute;\n  bottom: 50px;\n}\n.copyright-copyright {\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: normal;\n  white-space: nowrap;\n  color: #000;\n  font-weight: bold;\n  font-family: \"Open Sans\";\n  margin-top: 23px;\n  @media screen and (max-width: 600px) {\n    word-break: break-word;\n    margin-left: 114px;\n  }\n}\n.copyright-copyright-all{\n    display: flex;\n    align-items: center;\n    font-size: 13px;\n    font-weight: normal;\n   \n    color: #000;\n    margin-left: 5px;\n    font-family: \"Open Sans\";\n    font-weight: normal;\n    @media screen and (max-width: 600px) {\n      word-break: break-word;\n      margin-left: 114px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
